angular.module('core')
  .service('settingsApi', ['districtApi', 'schoolApi', 'teacherApi', 'classroomApi', 'studentApi', 'cancelableResourceFactory', '$state', '$q',
    function ($districtApi, $schoolApi, $teacherApi, $classroomApi, $studentApi, $cancelableResourceFactory, $state, $q) {

      var studentNameMapping = function(student) {
        var result = student.first_name;
        if (student.last_name) {
          result += " " + student.last_name;
        }
        // http://redmine/redmine/issues/49823
        if (student.username) {
          result += " - " + student.username;
        }
        return result;
      };

      var picture_passwords = [
        {name: 'Not selected', value: ''},
        {name: 'Flowers', value: '1'},
        {name: 'Cat', value: '2'},
        {name: 'Bug', value: '3'},
        {name: 'Pencils', value: '4'},
        {name: 'Hat', value: '5'},
        {name: 'Skull', value: '6'},
        {name: 'Bird', value: '7'},
        {name: 'Book', value: '8'},
        {name: 'Turtle', value: '9'}
      ];

      var getPicturePasswords = function() {
        return picture_passwords;
      };

      var getPicturePasswordName = function(picture_password) {
        // picture_password: '', '1', ..., '9'.
        if (!picture_password || picture_password.length === 0) {
          return picture_passwords[0].name;
        }

        // Note: backend returns 'N/A' when it fails to get picture_password
        if (picture_password === 'N/A') {
          return picture_password;
        }

        return picture_passwords[picture_password].name;
      };

      var isPasswordPictureAvailable = function(picturePassword) {
        // Not Selected
        if (!picturePassword || picturePassword.length === 0) {
          return false;
        }

        // Note: backend returns 'N/A' when it fails to get picture_password
        if (picturePassword === 'N/A') {
          return false;
        }

        return !!picture_passwords[picturePassword];
      };

      var classroomRosterMapping = function (body) {
        try {
          var roster = JSON.parse(body);
          roster.type = 'classroomRoster';
          var students = roster.students;
          _.each(students, function(student) {
            student.name = studentNameMapping(student);
          });
          return roster;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return {};
        }
      };

      var studentMapping = function(body) {
        try {
          var parsed = JSON.parse(body);
          var students = parsed.items;
          _.each(students, function(student) {
            student.name = studentNameMapping(student);
          });
          return parsed;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return {};
        }
      };

      var teacherMapping = function(body) {
        try {
          var parsed = JSON.parse(body);
          var teachers = parsed.items;
          _.each(teachers, function(teacher) {
            teacher.name = teacher.first_name + " " + teacher.last_name + " - " + teacher.email_address;
          });
          return parsed;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return {};
        }
      };

      var classroomMapping = function(body) {
        try {
          var parsed = JSON.parse(body);
          return parsed;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return {};
        }
      };

      var schoolMapping = function(body) {
        try {
          var parsed = JSON.parse(body);
          return parsed.data.schools;
        }
        catch(e) {
          console.error('Transform Error:', e.message);
          return [];
        }
      };

      var StudentMembership = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/roster', {
          id: '@id'
        }, {
          classroom: {
            url: '/m/classroom/:id/roster',
            method: 'GET',
            transformResponse: classroomRosterMapping
          },
          school: {
            url: '/m/school/:id/students',
            method: 'GET',
            transformResponse: studentMapping
          },
          unassignedSchool: {
            url: '/m/school/:id/students?unassignedOnly=true',
            method: 'GET',
            transformResponse: studentMapping
          },
          unassigned: {
            url: '/m/unassigned/students',
            method: 'GET',
            transformResponse: studentMapping
          }
        }
      );

      var MagnetoStudentMembership = $cancelableResourceFactory.createCacheableResource(null, '/m/magneto/classroom/:id/roster', {
          id: '@id'
        }, {
          classroom: {
            url: '/m/magneto/classroom/:id/roster',
            method: 'GET',
            transformResponse: classroomRosterMapping
          }
        }
      );

      var TeacherMembership = $cancelableResourceFactory.createCacheableResource(null, '/m/teacher/:id/settings', {
          id: '@id'
        }, {
          school: {
            url: '/m/school/:id/teachers',
            method: 'GET',
            transformResponse: teacherMapping
          },
          unassigned: {
            url: '/m/unassigned/teachers',
            method: 'GET',
            transformResponse: teacherMapping
          }
        }
      );

      var ClassroomMembership = $cancelableResourceFactory.createCacheableResource(null, '/m/classroom/:id/settings', {
          id: '@id'
        }, {
          school: {
            url: '/m/school/:id/classrooms',
            method: 'GET',
            transformResponse: classroomMapping
          }
        }
      );

      var SchoolMembership = $cancelableResourceFactory.createCacheableResource(null, '/n/districts/:districtId/schools', {
        districtId: '@districtId'
      },
      {
        query: {
          cache: true,
          url: '/n/districts/:districtId/schools',
          method: 'GET',
          isArray: true,
          transformResponse: schoolMapping
        }
      });

      var getClassrooms = function(districtId, schoolId) {
        var resource = ClassroomMembership.school({
          id: schoolId
        });

        // get classrooms from G2 so we can filter the inactive ones
        var navigationClassrooms = $classroomApi.getClassroomsForSchool(districtId, schoolId).catch(function (reason) {
          // Just return undefined to prevent propagation of the error.  This allows
          // us to skip filtering in case this call fails.

        });

        var promises = {
          provisionClassrooms: resource.$promise,
          navigationClassrooms: navigationClassrooms
        };

        return $q.all(promises).then(function (results) {
          if (!results.navigationClassrooms) {
            return results.provisionClassrooms.items;
          }

          var navClassroomsByPUID = _.indexBy(results.navigationClassrooms, 'provision_uid');

          var visibleClassrooms =  _.filter(results.provisionClassrooms.items, function (provisionClassroom) {
            return !!navClassroomsByPUID[provisionClassroom.provision_uid];
          });

          return visibleClassrooms;
        });
      };

      var getStudents = function(scid, success, error, unassignedOnly) {
        var promises;
        if (!scid || scid === -1) {
          promises = StudentMembership.unassigned();
        } else if (unassignedOnly) {
          promises = StudentMembership.unassignedSchool({id: scid});
        } else {
          promises = StudentMembership.school({id: scid});
        }

        promises.$promise.then(function(schoolStudents) {
          success(schoolStudents.items);
        });
      };

      var getTeachers = function(scid, success, error) {
        var promises;
        if (!scid || scid === -1) {
          promises = TeacherMembership.unassigned();
        } else {
          promises = TeacherMembership.school({id: scid});
        }

        promises.$promise.then(function(schoolTeachers) {
          success(schoolTeachers.items);
        });
      };

      var getSchools = function(districtId) {
        var promises = SchoolMembership.query({ districtId: districtId });
        return promises.$promise.then(function(schools) {
          return schools;
        });
      };

      var getClassroomRoster = function(cid, success, error) {
        var classroomRoster = StudentMembership.classroom({id: cid});
        classroomRoster.$promise.then(function(roster) {
            var authType = roster.authentication_type;

            _.each(roster.students, function (student) {
                student.picturePasswordName = getPicturePasswordName(student.picture_password);
                student.isPasswordPictureAvailable = authType === 1 && isPasswordPictureAvailable(student.picture_password);

                if (authType === 1) {
                    student.passwordText = student.picturePasswordName;
                } else if (authType === 2) {
                    student.passwordText = student.password;
                }
            });

            roster.students = _.sortByAll(roster.students, ['first_name', 'last_name']);

            success(roster);
        });

        return classroomRoster;
      };

      var getMagnetoClassroomRoster = function(classroomUid, success, error) {
        var classroomRoster = MagnetoStudentMembership.classroom({id: classroomUid});
        classroomRoster.$promise.then(function(roster) {
          success(roster);
        });
      };

      var saveClassroomRoster = function(item, success, error) {
        console.log(item);
        var roster = new StudentMembership(item);
        roster.$save([], function (result) {
            success(result);
            // Currently this clears the angular-cached-resource cache.  Clearing the Angular http cache
            // may also be necessary in some circumstances for student nav to update properly when it is
            // revisited.  See IN-3036
            $studentApi.clearStudentNavigationCache();
        }, error);
      };

      var saveMagnetoClassroomRoster = function(item, success, error) {
        console.log(item);
        var roster = new MagnetoStudentMembership(item);
        roster.$save([],
            function () {
              _.each(item.students, function(student) {
                if (student.reset_password) {
                  student.reset_password = false;
                  delete student.picture_password;
                }
              });
              success();
            }, error);
      };

      var createItem = function(id, success, error) {
        // add a timeout to allow the controller to initialize
        setTimeout(function() {
            // no need to request any data, just return an empty object
            // note that we will keep a reference to this object and saveItemSettings will work with it
            // so it must be modified instead of recreated
            success({});
        }, 100);
      };

      // @deprecated call individual endpoints based on context instead.  This is currently
      // used by "edit" feature in reporting pages.
      /* jshint -W074 */ // TODO: Fix maxcomplexity violation?
      var getItemSettings = function(type, params, success, error) {
        var id = 0;

        var itemGetApi;
        switch (type) {
          case 'district':
            id = params.districtId;
            switch ($state.params.pane) {
              case 'create':
                itemGetApi = createItem;
                break;
              default:
                itemGetApi = $districtApi.getDistrictSettings;
                break;
            }

            break;
          case 'school':
            id = params.schoolId;
            switch ($state.params.pane) {
              default:
                itemGetApi = createItem;
                break;
              case 'create':
                itemGetApi = createItem;
                break;
              case 'settings':
                itemGetApi = $schoolApi.getSchoolSettings;
                break;
            }

            break;
          case 'teacher':
            id = params.teacherId;
            switch($state.params.pane) {
              case 'reporting_settings':
                itemGetApi = $teacherApi.getTeacherProductSettings;
                break;
              case 'settings':
                itemGetApi = $teacherApi.getTeacherSettings;
                break;
            }
            break;
          case 'classroom':
            id = params.classroomId;
            switch ($state.params.pane) {
              case 'primary_graduation':
                itemGetApi = createItem;
                break;
              case 'roster':
              case 'roster_ro':
                itemGetApi = getClassroomRoster;
                break;
              case 'password_type':
                itemGetApi = $classroomApi.getPasswordStyles;
                break;
              case 'engagement_restrictions':
                itemGetApi = $classroomApi.getClassroomEngagementRestrictions;
                break;
              default:
                itemGetApi = $classroomApi.getClassroomSettings;
                break;
            }
            break;
          case 'student':
            id = params.studentId;
            switch ($state.params.pane) {
              case 'password':
                itemGetApi = $studentApi.getStudentsPasswords;
                break;
              default:
                itemGetApi = $studentApi.getStudentSettings;
                break;
            }
            break;
        }
        if (itemGetApi === undefined) {
          console.log('cannot find a service API for type: ' + type + ' params: ' + params);
          //callback(angular.copy(item));
          return;
        }

        return itemGetApi(id, success, error);
      };
      /* jshint +W074 */

      // @deprecated this is used by the "edit" feature
      // accessed via the reporting pages.  Individual settings endpoints should be
      // called instead of this.  getChangesToItem is available to determine which settings
      // have changed in an item.
      /* jshint -W074 */ // TODO: Fix maxcomplexity violation?
      var saveItemSettings = function(item, success, error) {
        if (item === undefined) {
          console.log('No item specified');
          return;
        }
        if (item.changed_attributes) {
          // if there is "changed_attributes" param, we want to send only those to the server
          var changed_attributes = [];
          for (var attr in item.changed_attributes) {
            if (item.changed_attributes[attr]) {
              changed_attributes.push(attr);
            }
          }
          if (changed_attributes.length) {
            console.log("only the following attributes changed", changed_attributes);
            var copy = _.pick(item, ["id", "provision_uid", "type"].concat(changed_attributes));
            item = copy;
          }
        }
        console.log('save called');
        switch (item.type) {
          case 'district':
            $districtApi.saveDistrictSettings(item, success, error);
            break;
          case 'school':
            $schoolApi.saveSchoolSettings(item, success, error);
            break;
          case 'teacher':
            $teacherApi.saveTeacherSettings(item, success, error);
            break;
          case 'teacher_product':
            $teacherApi.saveTeacherProductSettings(item, success, error);
            break;
          case 'classroom':
            $classroomApi.saveClassroomSettings(item, success, error);
            break;
          case 'classroomRoster':
            saveClassroomRoster(item, success, error);
            break;
          case 'classroomPassword':
            $classroomApi.savePasswordStyles(item, success, error);
            break;
          case 'classroomEngagementRestrictions':
            $classroomApi.saveClassroomEngagementRestrictions(item, success, error);
            break;
          case 'student':
            $studentApi.saveStudentSettings(item, success, error);
            break;
          case 'studentsPasswords':
            $studentApi.saveStudentsPasswords(item, success, error);
            break;
          default:
            console.log('cannot find a service API for saving item: ' + item);
            break;
        }
      };
      /* jshint +W074 */

      var getGenders = function() {
        return [
          {name: "--", code: "NotSpecified"},
          {name: "Male", code: "Male"},
          {name: "Female", code: "Female"},
          {name: "Other", code: "Other"}
          ];
      };

      var attributeChanged = function(item, attribute) {
        item.changed_attributes = item.changed_attributes || {};
        item.changed_attributes[attribute] = true;
      };

      // if there is "changed_attributes" param, we want to send only those to the server
      var getChangesToItem = function (item) {
        if (item.changed_attributes) {
          var changed_attributes = [];
          for (var attr in item.changed_attributes) {
            if (item.changed_attributes[attr]) {
              changed_attributes.push(attr);
            }
          }
          if (changed_attributes.length) {
            var copy = _.pick(item, ["id", "provision_uid", "type"].concat(changed_attributes));
            return copy;
          }
        }

        return item;
      };

      return {saveItemSettings: saveItemSettings,
              getItemSettings: getItemSettings,
              saveClassroomRoster: saveClassroomRoster,
              saveMagnetoClassroomRoster: saveMagnetoClassroomRoster,
              getChangesToItem: getChangesToItem,
              getGenders: getGenders,
              getStudents: getStudents,
              getTeachers: getTeachers,
              getSchools: getSchools,
              getClassrooms: getClassrooms,
              getClassroomRoster: getClassroomRoster,
              getMagnetoClassroomRoster: getMagnetoClassroomRoster,
              getPicturePasswords: getPicturePasswords,
              getPicturePasswordName: getPicturePasswordName,
              isPasswordPictureAvailable: isPasswordPictureAvailable,
              attributeChanged: attributeChanged };
    }]);
